export const SET_PROFILE = "SET_PROFILE";
export const SET_PROFILE_SETTINGS = "SET_PROFILE_SETTINGS";
export const SET_PROFILE_SETTINGS_CORE_VALUES =
  "SET_PROFILE_SETTINGS_CORE_VALUES";
export const SET_PROFILE_SETTINGS_MISSION_STATEMENT =
  "SET_PROFILE_SETTINGS_MISSION_STATEMENT";
export const SET_PROFILE_AVATAR = "SET_PROFILE_AVATAR";
export const SET_PROFILE_NOTIFICATIONS = "SET_PROFILE_NOTIFICATIONS";
export const SET_PROFILE_REPORT_FAVORITE = "SET_PROFILE_REPORT_FAVORITE";

export const SET_LOOKUPS = "SET_LOOKUPS";

export const SET_COMPANY = "SET_COMPANY";
export const SET_COMPANY_LOGO = "SET_COMPANY_LOGO";

export const SET_COMPANY_CORE_VALUES = "SET_COMPANY_CORE_VALUES";
export const SET_COMPANY_EDIT_CORE_VALUE = "SET_COMPANY_EDIT_CORE_VALUE";
export const DELETE_COMPANY_CORE_VALUE = "DELETE_COMPANY_CORE_VALUE";
export const SET_CORE_VALUE_ACTIVITES = "SET_CORE_VALUE_ACTIVITES";
export const SET_MISSION_STATEMENT_ACTIVITES =
  "SET_MISSION_STATEMENT_ACTIVITES";
export const SET_CORE_VALUE_ACTIONS = "SET_CORE_VALUE_ACTIONS";
export const SET_COMPANY_STRATEGIC_ANCHORS = "SET_COMPANY_STRATEGIC_ANCHORS";
export const DELETE_COMPANY_STRATEGIC_ANCHOR =
  "DELETE_COMPANY_STRATEGIC_ANCHOR";
export const SET_COMPANY_BUSINESS_METRICS = "SET_COMPANY_BUSINESS_METRICS";
export const SET_COMPANY_BUSINESS_METRIC = "SET_COMPANY_BUSINESS_METRIC";
export const DELETE_COMPANY_BUSINESS_METRIC = "DELETE_COMPANY_BUSINESS_METRIC";
export const SET_COMPANY_BUSINESS_METRIC_ITEMS =
  "SET_COMPANY_BUSINESS_METRIC_ITEMS";
export const SET_COMPANY_BUSINESS_METRIC_ITEM =
  "SET_COMPANY_BUSINESS_METRIC_ITEM";
export const DELETE_COMPANY_BUSINESS_METRIC_ITEM =
  "DELETE_COMPANY_BUSINESS_METRIC_ITEM";
export const SET_COMPANY_CUSTOM_FIELDS = "SET_COMPANY_CUSTOM_FIELDS";
export const SET_COMPANY_CUSTOM_FIELD = "SET_COMPANY_CUSTOM_FIELD";
export const DELETE_COMPANY_CUSTOM_FIELD = "DELETE_COMPANY_CUSTOM_FIELD";

export const SET_CUSTOMERS_OVERVIEW = "SET_CUSTOMERS_OVERVIEW";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_CUSTOMER = "SET_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const SET_CUSTOMER_PRIMARY_CONTACTS = "SET_CUSTOMER_PRIMARY_CONTACTS";
export const SET_CUSTOMER_CORE_COACHES = "SET_CUSTOMER_CORE_COACHES";
export const SET_CUSTOMER_SETTINGS = "SET_CUSTOMER_SETTINGS";
export const SET_PARTNER_CUSTOMERS = "SET_PARTNER_CUSTOMERS";

export const SET_CORE_COACHES = "SET_CORE_COACHES";
export const SET_CORE_COACH = "SET_CORE_COACH";
export const SET_CORE_COACH_CUSTOMERS = "SET_CORE_COACH_CUSTOMERS";

export const SET_MISSION_STATEMENTS = "SET_MISSION_STATEMENTS";
export const SET_COMPANY_MISSION_STATEMENT = "SET_COMPANY_MISSION_STATEMENT";

export const SET_TEAMS = "SET_TEAMS";
export const SET_TEAM = "SET_TEAM";
export const SET_EDIT_TEAM = "SET_EDIT_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
export const SET_TEAM_USERS = "SET_TEAM_USERS";
export const SET_TEAM_SUBTEAMS = "SET_TEAM_SUBTEAMS";
export const SET_TEAM_USER = "SET_TEAM_USER";
export const DELETE_TEAM_USER = "DELETE_TEAM_USER";
export const SET_TEAM_ACTIVITIES = "SET_TEAM_ACTIVITIES";
export const SET_TEAM_LOGO = "SET_TEAM_LOGO";

export const SET_USERS = "SET_USERS";
export const SET_SEARCH_USERS = "SET_SEARCH_USERS";
export const SET_EDIT_USER = "SET_EDIT_USER";
export const SET_EDIT_USER_ROLE = "SET_EDIT_USER_ROLE";
export const SET_USER_TEAMS = "SET_USER_TEAMS";
export const SET_USER = "SET_USER";
export const DELETE_USER = "DELETE_USER";
export const SET_MANAGERS = "SET_MANAGERS";
export const SET_ACTIVITIES = "SET_ACTIVITIES";
export const SET_MANAGER_ACTIVITIES = "SET_MANAGER_ACTIVITIES";
export const SET_MANAGED_USERS = "SET_MANAGED_USERS";
export const SET_REVIEWERS = "SET_REVIEWERS";

export const SET_SURVEYS = "SET_SURVEYS";
export const SET_OUTSTANDING_SURVEYS = "SET_OUTSTANDING_SURVEYS";
export const SET_EDIT_SURVEY = "SET_EDIT_SURVEY";
export const SET_SURVEY_INSTANCES = "SET_SURVEY_INSTANCES";
export const SET_SURVEY_SCHEDULE = "SET_SURVEY_SCHEDULE";
export const SET_SURVEY_TEMPLATES = "SET_SURVEY_TEMPLATES";
export const SET_SURVEY_QUESTIONS = "SET_SURVEY_QUESTIONS";
export const SET_SURVEY_SCHEDULE_PAUSED = "SET_SURVEY_SCHEDULE_PAUSED";
export const SET_SURVEY_SCHEDULE_ID = "SET_SURVEY_SCHEDULE_ID";
export const DELETE_SURVEY = "DELETE_SURVEY";
export const COMPLETE_SURVEY = "COMPLETE_SURVEY";
export const SET_SURVEY_INSTANCE = "SET_SURVEY_INSTANCE";
export const DELETE_SURVEY_INSTANCE = "DELETE_SURVEY_INSTANCE";
export const CLOSE_SURVEY_INSTANCE = "CLOSE_SURVEY_INSTANCE";

export const SET_RESOURCES = "SET_RESOURCES";
export const SET_OUTSTANDING_RESOURCES = "SET_OUTSTANDING_RESOURCES";
export const SET_RESOURCES_LIBRARY = "SET_RESOURCES_LIBRARY";
export const SET_RESOURCE_FAVORITE = "SET_RESOURCE_FAVORITE";
export const SET_RESOURCE_SCHEDULE = "SET_RESOURCE_SCHEDULE";
export const DELETE_SCHEDULED_RESOURCE = "DELETE_SCHEDULED_RESOURCE";
export const SET_RESOURCE = "SET_RESOURCE";
export const DELETE_RESOURCE = "DELETE_RESOURCE";
export const SET_RESOURCE_SCHEDULES = "SET_RESOURCE_SCHEDULES";

export const SET_TASKS = "SET_TASKS";
export const SET_ALERTS = "SET_ALERTS";

export const SET_REPORTING_LIST = "SET_REPORTING_LIST";
export const SET_REPORTING_RETURN_URL = "SET_REPORTING_RETURN_URL";
export const SET_REPORTING_TIMEFRAME = "SET_REPORTING_TIMEFRAME";
export const SET_REPORTING_SURVEY_REPORT = "SET_REPORTING_SURVEY_REPORT";
export const SET_REPORTING_SURVEY_TEXT_RESPONSES =
  "SET_REPORTING_SURVEY_TEXT_RESPONSES";
export const SET_REPORTING_SURVEY_ANSWER_USERS =
  "SET_REPORTING_SURVEY_ANSWER_USERS";
export const SET_REPORTING_RESOURCES = "SET_REPORTING_RESOURCES";
export const SET_REPORTING_INSTANCES = "SET_REPORTING_INSTANCES";
export const SET_REPORTING_SURVEYS = "SET_REPORTING_SURVEYS";
export const SET_REPORTING_PARTICIPATION = "SET_REPORTING_PARTICIPATION";
export const SET_REPORTING_TREND = "SET_REPORTING_TREND";
export const SET_REPORTING_HEATMAP = "SET_REPORTING_HEATMAP";
export const SET_REPORTING_HEATMAP_DETAIL = "SET_REPORTING_HEATMAP_DETAIL";
export const SET_REPORTING_GOALS = "SET_REPORTING_GOALS";
export const SET_REPORTING_GOALS_TRENDS = "SET_REPORTING_GOALS_TRENDS";
export const SET_REPORTING_TEAM_GOALS = "SET_REPORTING_TEAM_GOALS";
export const SET_REPORTING_USAGE = "SET_REPORTING_USAGE";
export const SET_REPORTING_USAGE_TRENDS = "SET_REPORTING_USAGE_TRENDS";
export const SET_REPORTING_PULSE = "SET_REPORTING_PULSE";
export const SET_REPORTING_OVERALL_SCORE = "SET_REPORTING_OVERALL_SCORE";
export const SET_REPORTING_REVIEW = "SET_REPORTING_REVIEW";
export const SET_REPORTING_RECOGNITION = "SET_REPORTING_RECOGNITION";
export const SET_REPORTING_MANAGER_SCORE = "SET_REPORTING_MANAGER_SCORE";
export const SET_REPORTING_TEAMS = "SET_REPORTING_TEAMS";
export const SET_REPORTING_USERS = "SET_REPORTING_USERS";
export const SET_REPORTING_BUSINESS_METRICS_TREND =
  "SET_REPORTING_BUSINESS_METRICS_TREND";
export const SET_REPORTING_BUSINESS_METRIC_ID =
  "SET_REPORTING_BUSINESS_METRIC_ID";
export const SET_REPORTING_TREND_TYPES = "SET_REPORTING_TREND_TYPES";
export const SET_REPORTING_MULTIPLE_TRENDS = "SET_REPORTING_MULTIPLE_TRENDS";
export const SET_REPORTING_SORT_BY = "SET_REPORTING_SORT_BY";
export const SET_REPORTING_SORT_DESC = "SET_REPORTING_SORT_DESC";

export const SET_ENGAGEMENT = "SET_ENGAGEMENT";

export const SET_DRAWER = "SET_DRAWER";

export const SET_BILLING = "SET_BILLING";
export const SET_BILLING_HISTORY = "SET_BILLING_HISTORY";
export const SET_BILLING_METHODS = "SET_BILLING_METHODS";
export const SET_BILLING_TREND = "SET_BILLING_TREND";
export const SET_BILLABLE_USER_COUNT = "SET_BILLABLE_USER_COUNT";
export const SET_PARTNER_BILLING = "SET_PARTNER_BILLING";
export const SET_PARTNER_BILLING_HISTORY = "SET_PARTNER_BILLING_HISTORY";

export const SET_CHECKINS = "SET_CHECKINS";
export const SET_CHECKIN = "SET_CHECKIN";
export const SET_CHECKIN_HISTORY = "SET_CHECKIN_HISTORY";
export const SET_CHECKIN_TAB = "SET_CHECKIN_TAB";
export const SET_CHECKIN_TALKINGPOINT = "SET_CHECKIN_TALKINGPOINT";
export const COMPLETE_CHECKIN_TALKINGPOINT = "COMPLETE_CHECKIN_TALKINGPOINT";
export const UNCOMPLETE_CHECKIN_TALKINGPOINT =
  "UNCOMPLETE_CHECKIN_TALKINGPOINT";
export const DELETE_CHECKIN_TALKINGPOINT = "DELETE_CHECKIN_TALKINGPOINT";
export const SET_CHECKIN_TALKINGPOINT_NOTE = "SET_CHECKIN_TALKINGPOINT_NOTE";
export const DELETE_CHECKIN_TALKINGPOINT_NOTE =
  "DELETE_CHECKIN_TALKINGPOINT_NOTE";
export const SET_CHECKIN_ACTIONITEM = "SET_CHECKIN_ACTIONITEM";
export const DELETE_CHECKIN_ACTIONITEM = "DELETE_CHECKIN_ACTIONITEM";
export const COMPLETE_CHECKIN_ACTIONITEM = "COMPLETE_CHECKIN_ACTIONITEM";
export const REOPEN_CHECKIN_ACTIONITEM = "REOPEN_CHECKIN_ACTIONITEM";
export const SET_CHECKIN_DRAWER = "SET_CHECKIN_DRAWER";
export const SET_ACTION_ITEMS = "SET_ACTION_ITEMS";
export const REOPEN_ACTIONITEM = "REOPEN_ACTIONITEM";
export const COMPLETE_ACTIONITEM = "COMPLETE_ACTIONITEM";
export const SET_ACTION_ITEM_NOTE = "SET_ACTION_ITEM_NOTE";
export const DELETE_ACTION_ITEM_NOTE = "DELETE_ACTION_ITEM_NOTE";
export const SET_CHECKIN_START = "SET_CHECKIN_START";
export const SET_UNFINISHED_CHECKINS = "SET_UNFINISHED_CHECKINS";
export const SET_CHECKIN_UNSTART = "SET_CHECKIN_UNSTART";
export const SET_CHECKIN_REVIEW_ANSWER = "SET_CHECKIN_REVIEW_ANSWER";
export const SET_CHECKIN_REVIEW_FEEDBACK = "SET_CHECKIN_REVIEW_FEEDBACK";
export const SET_TALKING_POINT = "SET_TALKING_POINT";
export const SNOOZE_CHECKIN_TALKINGPOINT = "SNOOZE_CHECKIN_TALKINGPOINT";
export const ARCHIVE_CHECKIN = "ARCHIVE_CHECKIN";
export const DELETE_CHECKIN = "DELETE_CHECKIN";

export const SET_GOALS = "SET_GOALS";
export const SET_GOAL = "SET_GOAL";
export const REOPEN_GOAL = "REOPEN_GOAL";
export const DELETE_GOAL = "DELETE_GOAL";
export const SET_GOAL_NOTE = "SET_GOAL_NOTE";
export const DELETE_GOAL_NOTE = "DELETE_GOAL_NOTE";
export const SET_GOAL_TASK = "SET_GOAL_TASK";
export const REOPEN_GOAL_TASK = "REOPEN_GOAL_TASK";
export const DELETE_GOAL_TASK = "DELETE_GOAL_TASK";

export const SET_RECOGNITIONS = "SET_RECOGNITIONS";
export const SET_RECOGNITION = "SET_RECOGNITION";

export const SET_REVIEW_OVERVIEW = "SET_REVIEW_OVERVIEW";
export const SET_PENDING_REVIEWS = "SET_PENDING_REVIEWS";
export const SET_PENDING_REVIEW_ANSWER = "SET_PENDING_REVIEW_ANSWER";
export const SET_PENDING_REVIEW_FEEDBACK = "SET_PENDING_REVIEW_FEEDBACK";

export const SET_SETTINGS_REVIEW_CATEGORIES = "SET_SETTINGS_REVIEW_CATEGORIES";
export const TOGGLE_SETTINGS_REVIEW_CATEGORY =
  "TOGGLE_SETTINGS_REVIEW_CATEGORY";
export const TOGGLE_SETTINGS_REVIEW_QUESTIONS =
  "TOGGLE_SETTINGS_REVIEW_QUESTIONS";
export const SET_REVIEW_QUESTION = "SET_REVIEW_QUESTION";
export const REMOVE_REVIEW_QUESTION = "REMOVE_REVIEW_QUESTION";
export const SET_REVIEW_QUESTION_CATEGORY = "SET_REVIEW_QUESTION_CATEGORY";
export const REMOVE_REVIEW_QUESTION_CATEGORY =
  "REMOVE_REVIEW_QUESTION_CATEGORY";
export const ADD_SETTINGS_REVIEW_QUESTIONS = "ADD_SETTINGS_REVIEW_QUESTIONS";
export const REMOVE_SETTINGS_REVIEW_QUESTIONS =
  "REMOVE_SETTINGS_REVIEW_QUESTIONS";
export const SET_SETTINGS_ANNUAL_REVIEW_SECTIONS =
  "SET_SETTINGS_ANNUAL_REVIEW_SECTIONS";
export const SET_SETTINGS_ANNUAL_REVIEW_SECTION =
  "SET_SETTINGS_ANNUAL_REVIEW_SECTION";
export const SET_SETTINGS_ANNUAL_REVIEW_QUESTION =
  "SET_SETTINGS_ANNUAL_REVIEW_QUESTION";
export const REMOVE_SETTINGS_ANNUAL_REVIEW_SECTION =
  "REMOVE_SETTINGS_ANNUAL_REVIEW_SECTION";
export const REMOVE_SETTINGS_ANNUAL_REVIEW_QUESTION =
  "REMOVE_SETTINGS_ANNUAL_REVIEW_QUESTION";
export const SET_SETTINGS_ANNUAL_REVIEW_RATINGS =
  "SET_SETTINGS_ANNUAL_REVIEW_RATINGS";

export const SET_ANNUAL_REVIEW_OVERVIEW = "SET_ANNUAL_REVIEW_OVERVIEW";
export const SET_ANNUAL_REVIEWS = "SET_ANNUAL_REVIEWS";
export const SET_ANNUAL_REVIEW = "SET_ANNUAL_REVIEW";
export const SET_ANNUAL_REVIEW_TAB = "SET_ANNUAL_REVIEW_TAB";
export const SET_ANNUAL_REVIEW_DRAWER = "SET_ANNUAL_REVIEW_DRAWER";
export const SET_ANNUAL_REVIEW_HISTORY = "SET_ANNUAL_REVIEW_HISTORY";
export const SET_ANNUAL_REVIEW_ANSWER = "SET_ANNUAL_REVIEW_ANSWER";
export const SET_ANNUAL_REVIEW_COMPLETE_QUESTIONS =
  "SET_ANNUAL_REVIEW_COMPLETE_QUESTIONS";
export const SET_ANNUAL_REVIEW_SIGNOFF = "SET_ANNUAL_REVIEW_SIGNOFF";
export const SET_ANNUAL_REVIEW_RATING = "SET_ANNUAL_REVIEW_RATING";
export const SET_ANNUAL_REVIEW_COMPLETE = "SET_ANNUAL_REVIEW_COMPLETE";
export const SET_ANNUAL_REVIEWS_READY = "SET_ANNUAL_REVIEWS_READY";
export const SET_ANNUAL_REVIEWS_SIGNOFF_READY =
  "SET_ANNUAL_REVIEWS_SIGNOFF_READY";

export const SET_CORE_CARD = "SET_CORE_CARD";
export const SET_CORECARD_DRAWER = "SET_CORECARD_DRAWER";
export const RESET_CORECARD_LIST = "RESET_CORECARD_LIST";
export const REMOVE_CORE_CARD = "REMOVE_CORE_CARD";
export const SET_CORE_CARD_RANKINGS = "SET_CORE_CARD_RANKINGS";

export const SET_PULSE_OVERVIEW = "SET_PULSE_OVERVIEW";
export const SET_PULSE_CATEGORIES = "SET_PULSE_CATEGORIES";
export const TOGGLE_PULSE_CATEGORY = "TOGGLE_PULSE_CATEGORY";
export const TOGGLE_PULSE_QUESTION = "TOGGLE_PULSE_QUESTION";
export const SET_OUTSTANDING_PULSES = "SET_OUTSTANDING_PULSES";
export const SET_PULSE_FEEDBACK = "SET_PULSE_FEEDBACK";
export const SET_PULSE_FEEDBACK_ACKNOWLEDGE = "SET_PULSE_FEEDBACK_ACKNOWLEDGE";
export const SET_PULSE_CATEGORY = "SET_PULSE_CATEGORY";
export const REMOVE_PULSE_CATEGORY = "REMOVE_PULSE_CATEGORY";
export const SET_PULSE_SUB_CATEGORY = "SET_PULSE_SUB_CATEGORY";
export const SET_PULSE_QUESTION = "SET_PULSE_QUESTION";
export const REMOVE_PULSE_QUESTION = "REMOVE_PULSE_QUESTION";

export const SET_INSIGHTS = "SET_INSIGHTS";
export const SET_INSIGHTS_DRAWER = "SET_INSIGHTS_DRAWER";
export const MARK_INSIGHT_READ = "MARK_INSIGHT_READ";
export const DELETE_INSIGHT = "DELETE_INSIGHT";
